import React, { useEffect, useState } from 'react';
import cn from "classnames";
import ReactTooltip from "react-tooltip";
import { TableHeader } from "./TableHeader";
import BackButton from "../../../../components/utils/BackButton";
import Select from "react-select";
import Input from "../../../../components/utils/Input";
import DateInput from "../../../../components/utils/DateInput";
import { useDispatch, useSelector } from "react-redux";
import {
    createInvoice,
    fetchInvoice,
    fetchRawsList,
    fetchSuppliers,
    getLastInventory,
    updateInvoice
} from "../../../../action";
import swal from 'sweetalert';
import {
    suppliersLoadingSelector,
    suppliersSelector
} from "../../../../selectors/forms";
import ErrorContainer from "../../../../components/utils/ErrorContainer";
import { loaderRawsSelector, selectedRawsByType } from '../../../../selectors/raw';
import { MEASURES_RAW } from '../../../../containers/rawmaterials/constansts';
import { styles } from '../../../../containers/goods/styles';
import Loader from '../../../../components/utils/Loader';
import { isEmpty } from 'lodash';
import { fetchFilials } from '../../../../action/handbook';
import moment from 'moment';
import { parseNumToFixed } from '../../../../utils/common';

const InvoiceForm = ({match, history}) => {
    let copyId = null;
    if (window.history && window.history.state && window.history.state.state) {
        copyId = window.history.state.state.invoiceId;
    }
    const {id} = match.params;
    const dispatch = useDispatch();
    const UImobile = useSelector(state => state.UImobile);

    const points = useSelector(state => state.handbook.filials);
    const pointsCount = useSelector(state => state.handbook.count.filials);
    const pointsLoading = useSelector(state => state.loaders.filials);
    const suppliers = useSelector(suppliersSelector);
    const raws = useSelector(selectedRawsByType('raw'));

    const suppliersLoading = useSelector(suppliersLoadingSelector);
    const rawMaterialsLoading = useSelector(loaderRawsSelector);
    const loadingInvoice = useSelector(state => state.loaders.invoice);
    const loading = loadingInvoice || suppliersLoading || rawMaterialsLoading || pointsLoading;
    const user = useSelector(state => state.user.info);

    const initData = {
        number: null,
        point: null,
        date: new Date(),
        note: '',
        totalSum: 0,
        payment: 'none',
        supplier: null,
        status: true,
        rawMaterials: [{
            name: null,
            price: 0,
            totalPrice: 0,
            quantity: 0,
            balance: 0,
            productscategory: {},
        }],
        changeLog: {},
    }

    const [data, setData] = useState(initData);
    const [blockData, setBlockData] = useState(!!id ? true : false);

    const setInvoice = (field) => (value) => {
        const updated = {...data};
        let dataValue = null;
        if (value) {
            if (value.value) {
                dataValue = value.value;
            } else {
                dataValue = value;
            }
        }

        if (id) {
            const date = moment().format('YYYY.MM.DD');
            const time = moment().format('HH:mm:ss');
            const username = user ? user.name ? user.name : user.username : null;

            const data = { 
                old: updated[field] || null, 
                new: dataValue,
                time,
                username,
            };

            const currentLog = updated.changeLog[date] || {};
            const updatedLog = { ...currentLog, [field]: data };
            updated.changeLog = { ...updated.changeLog, [date]: updatedLog };
        }

        updated[field] = dataValue;
        setData(updated);
    }

    const setPoint = (point) => {
        if (point && !point.enableConsumption) return swal({
            title: `Создание накладной на филиале ${point.label} невозможно`,
            text: '"Списание сырья" отключено',
            icon: "error",
            dangerMode: true,
            button: "Ок",
        });

        const updated = {...data};

        if (id) {
            const date = moment().format('YYYY.MM.DD');
            const time = moment().format('HH:mm:ss');
            const username = user ? user.name ? user.name : user.username : null;

            const dataPoint = { 
                old: updated.point ? updated.point.id ? updated.point.id : updated.point : null, 
                new: point.value,
                time,
                username,
            }

            const currentLog = updated.changeLog[date] || {};
            const updatedLog = { ...currentLog, point: dataPoint };
            updated.changeLog = { ...updated.changeLog, [date]: updatedLog };
        }

        let dataValue = null;
        if (point) dataValue = point.value;
        updated.point = dataValue;
        setData(updated);
    }

    useEffect(() => {
        const getData = async () => {
            if (id) {
                const invoice = await dispatch(fetchInvoice(id));
                const changeLog = invoice.changeLog ? invoice.changeLog : {};
                setData({...invoice, changeLog});


                const lastInventory = await dispatch(getLastInventory(invoice.point));

                if (lastInventory && lastInventory.error) {
                    return swal({
                        title: `Редактирование невозможно`,
                        text: lastInventory.error.message || '',
                        icon: "warning",
                        dangerMode: true,
                        button: "Ок",
                    }).then(() => {
                        return history.goBack();
                    });
                };

                if (!isEmpty(lastInventory) && moment(lastInventory.date) > moment(invoice.date)) {
                    setBlockData(true);
                } else {
                    setBlockData(false);
                }
            } else if (copyId) {
                const originalInvoice = await dispatch(fetchInvoice(copyId));
                const copyData = {
                    ...originalInvoice,
                    id: null,
                    number: null,
                    date: new Date(),
                    changeLog: {},
                    isPaid: null,
                    payment: null,
                    paymented_at: null
                };
                setData(copyData);
            }
        }        
        if (id || copyId) getData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, copyId]);

    const isMobile = window.innerWidth <= 768;

    const textareaStyles = {
        border: "1px solid #e2e5ec",
        boxShadow: "none",
        backgroundColor: "#fff",
        color: "#333",
        padding: "10px",
        fontSize: "14px",
        width: "163px",
        height: "38px",
        resize: "horizontal",
        overflow: "auto",
        outline: "none",
        transition: "border-color 0.3s ease, box-shadow 0.3s ease",
    };

    useEffect(() => {
        if (isEmpty(points) || points.length < pointsCount) dispatch(fetchFilials(null, true));
        if (isEmpty(raws)) dispatch(fetchRawsList());
        if (isEmpty(suppliers)) dispatch(fetchSuppliers());
        dispatch(fetchSuppliers());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    const renderPointLabel = (point) => {
        if (!point) return '';
        return `${point.city.name}, ${point.street || 'Улица не указана'} ${point.house || ''}`
    }

    const pointOptions = points.map(point => ({
        value: point.id,
        label: renderPointLabel(point),
        enableConsumption: point.enableConsumption || false,
    }));

    const supplierOptions = suppliers.map(supplier => ({
        value: supplier.id,
        label: supplier.name,
    }));

    const totalSum = data.rawMaterials.reduce((sum, row) => sum + parseFloat(row.totalPrice || 0), 0).toFixed(2);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const sended = {...data};

        sended.rawMaterials = sended.rawMaterials.filter((raw) => {
            if (!raw.id) return false;
            if (raw.price || raw.totalPrice || raw.quantity) return true;
            return false;
        });
        sended.totalSum = totalSum;

        const rawsWithBalance = sended.rawMaterials.filter((raw) => raw.balance && raw.balance > 0);
        if (rawsWithBalance && rawsWithBalance.length > 0) sended.fullRealization = false;

        if (isEmpty(sended.rawMaterials)) {
            setData(sended);
            return swal({
                title: "Нет данных о сырье.",
                text: 'Добавьте данные о сырье для сохранения накладной.',
                icon: "warning",
                dangerMode: true,
                button: "Назад"
            }).then(() => {
                return false;                   
            });
        }
        if (id) {
            if (!blockData) {
                const result = await dispatch(updateInvoice(id, sended));
                if (result) {
                    return swal({
                        title: `Накладная ${result} успешно обновлена`,
                        icon: "success",
                        button: "Ок"
                    }).then(() => {
                        return history.goBack();
                    });
                }
            } else {
                const sendedBlockData = { note: sended.note };
                const result = await dispatch(updateInvoice(id, sendedBlockData));
                if (result) {
                    return swal({
                        title: `Накладная ${result} успешно обновлена`,
                        icon: "success",
                        button: "Ок"
                    }).then(() => {
                        return history.goBack();
                    });
                }
            }
        } else {
            const result = await dispatch(createInvoice(sended));
            if (result) {
                return swal({
                    title: `Накладная ${result} успешно создана`,
                    icon: "success",
                    button: "Ок"
                }).then(() => {
                    return history.goBack();;                   
                });
            }
        }
        
    };

    const addRow = () => {
        const updated = {...data};
        updated.rawMaterials.push({
            name: null,
            price: 0,
            totalPrice: 0,
            quantity: 0,
            balance: 0,
            productscategory: {},
        });
        setData(updated);
    };

    const deleteRow = (index) => {
        const updated = {...data};
        if (id) {
            const raw = updated.rawMaterials.find((raw, rawIndex) => index === rawIndex);
            if (raw.id) {
                const date = moment().format('YYYY.MM.DD');
                const time = moment().format('HH:mm:ss');
                const username = user ? user.name ? user.name : user.username : null;
                
                const deletedProduct = {
                    id: raw.id || null,
                    name: raw.name || null,
                    type: 'raw',
                    time,
                    username,
                };
                
                const currentLog = updated.changeLog[date] || {};
                const deletedProducts = [ ...(currentLog.deletedProducts || []), deletedProduct ];
                const updatedLog = { ...currentLog, deletedProducts };
                updated.changeLog = { ...updated.changeLog, [date]: updatedLog };
            }
        }
        updated.rawMaterials = updated.rawMaterials.filter((raw, rawIndex) => index !== rawIndex);
        setData(updated);
    };

    const availableRawMaterialOptions = (id) => {
        const result = raws.filter((raw) => {
            if (raw.id === id) return true;
            if (data.rawMaterials.some((dataraw) => dataraw.id === raw.id)) return false;
            return true;
        })
        .map((raw) => ({
            label: raw.name,
            value: raw.id,
        }));
        return result;
    };

    const getRawValue = (id, name) => {
        if (!id) return;
        const result = raws.find((raw) => raw.id === id);
        if (!result || !result.id) return { label: name, value: id, measure: null } 
        return { label: result.name, value: id, measure: result.measure };
    }

    const handleMaterialChange = (index, option) => {
        const updated = {...data};
        const { rawMaterials } = updated;
        let raw = null
        if (option && option.value) raw = raws.find((raw) => raw.id === option.value);

        if (id) {
            const date = moment().format('YYYY.MM.DD');
            const time = moment().format('HH:mm:ss');
            const username = user ? user.name ? user.name : user.username : null;
            
            const addedProduct = {
                old: {
                    id: rawMaterials[index] && rawMaterials[index].id ? rawMaterials[index].id : null,
                    type: 'raw',
                    name: rawMaterials[index] && rawMaterials[index].name ? rawMaterials[index].name : null,
                },
                new: {
                    id: raw ? raw.id : null,
                    type: 'raw',
                    name: raw.name ? raw.name : null,
                },
                time,
                username,
            };
            
            const currentLog = updated.changeLog[date] || {};
            const productsAdd = [ ...(currentLog.productsAdd || []), addedProduct ];
            const updatedLog = { ...currentLog, productsAdd };
            updated.changeLog = { ...updated.changeLog, [date]: updatedLog };
        }

        rawMaterials[index] = {
            ...rawMaterials[index],
            name: raw.name ? raw.name : null,
            id: raw ? raw.id : null,
            price: raw ? raw.last_price || 0 : 0,
            totalPrice: (rawMaterials[index].quantity || 0) * (raw ? raw.last_price : 0),
            productscategory:  (raw && raw.productscategory) ? raw.productscategory.id : null,
        }

        updated.rawMaterials = rawMaterials;
        setData(updated);
    }

    const handleChange = (index, field, value) => {
        const updated = {...data};
        const { rawMaterials } = updated;

        if (id) {
            const date = moment().format('YYYY.MM.DD');
            const time = moment().format('HH:mm:ss');
            const username = user ? user.name ? user.name : user.username : null;
            
            const product = {
                id: updated.rawMaterials[index].id || null,
                name: updated.rawMaterials[index].name || null,
                type: 'raw',
                [field]: {
                    old: updated.rawMaterials[index][field] || null,
                    new: value,
                },
                time,
                username,
            };
            
            const currentLog = updated.changeLog[date] || {};
            const productsData = [ ...(currentLog.products || []), product ];
            const updatedLog = { ...currentLog, products: productsData };
            updated.changeLog = { ...updated.changeLog, [date]: updatedLog };
        }

        const updatedRaw = rawMaterials[index];

        switch (field) {
            case 'price': {
                if (updatedRaw.quantity) updatedRaw.totalPrice = parseNumToFixed(parseFloat(updatedRaw.quantity * value));
                break;
            }
            case 'totalPrice': {
                if (updatedRaw.quantity) updatedRaw.price = parseNumToFixed(parseFloat(value / updatedRaw.quantity));
                break;
            }
            case 'quantity': {
                if (updatedRaw.price) updatedRaw.totalPrice = parseNumToFixed(parseFloat(updatedRaw.price * value));
                const usedQuantity = updatedRaw.quantity - (updatedRaw.balance || 0);
                updatedRaw.balance = parseFloat(value) - usedQuantity;
                if (updatedRaw.balance > 0) updatedRaw.dateRealization = null;
                break;
            }
            default: {
                break
            }
        }

        updatedRaw[field] = value;
        updated.rawMaterials = rawMaterials;
        setData(updated);
    }

    if (loading) return (
        <div className='kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid'>
            <div style={styles.tableLoading}><Loader text='Загружаю данные'/></div>
        </div>
    );

    const isValid = () => {
        if (isEmpty(data.rawMaterials) || !data.number || !data.supplier || !data.date || !data.point) return false;
        return true;
    }

    if (isMobile) {
        return (
            <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid" style={{marginTop: 25}}>
                <div className="kt-grid kt-grid--desktop kt-grid--ver-desktop kt-todo">
                    <div className="kt-grid__item kt-grid__item--fluid kt-todo__content">
                        <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid"
                             style={{padding: 0}}>
                            <div className="kt-portlet kt-portlet--mobile">
                                <div className="kt-portlet__body kt-portlet__body--fit">
                                    <div
                                        style={{position: 'relative', marginBottom: 0}}
                                        className={cn('kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded')}
                                    >
                                        <div className="kt-subheader__mobile-wrapper">
                                            <div className="kt-subheader not-mt kt-grid__item">
                                                <div className="kt-container kt-container--fluid">
                                                    <div className="kt-subheader__main">
                                                        <div className="kt-subheader__mobile-header">
                                                            <div className="kt-subheader__mobile-actions">
                                                                <BackButton/>
                                                                <button
                                                                    onClick={handleSubmit}
                                                                    className={cn({ 'btn btn-success  kt-spinner--right kt-spinner--sm kt-spinner--light': true, 'kt-spinner': loading })}
                                                                    disabled={!isValid() || loading}                                                    >
                                                                    Сохранить
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="kt-subheader__mobile-actions">
                                                            <div style={{width: 120, height: 50}}>
                                                                <Input
                                                                    disabled={blockData}
                                                                    placeholder="Номер"
                                                                    value={data.number}
                                                                    onChange={(e) => setInvoice('number')(e.target.value)}
                                                                    isClearable={true}
                                                                />
                                                            </div>
                                                            <div style={{width: 120, height: 50}}>
                                                                <DateInput
                                                                    disabled={blockData}
                                                                    showPopperArrow={false}
                                                                    placeholderText="Дата"
                                                                    selected={new Date(data.date)}
                                                                    onChange={setInvoice('date')}
                                                                    showTimeSelect
                                                                    timeFormat="HH:mm:ss"
                                                                    timeIntervals={1}
                                                                    dateFormat="dd.MM.yyyy HH:mm:ss"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="kt-subheader__mobile-actions">
                                                            <div style={{width: 120, height: 50}}>
                                                                <Select
                                                                    isDisabled={blockData}
                                                                    options={supplierOptions}
                                                                    placeholder="Поставщик"
                                                                    isClearable={true}
                                                                    onChange={setInvoice('supplier')}
                                                                    value={data.supplier
                                                                        ? data.supplier.id 
                                                                        ? { label: data.supplier.name, value: data.supplier.id } 
                                                                        : supplierOptions.find((reason) => reason.id === data.supplier) 
                                                                    : null}
                                                                    isLoading={suppliersLoading}
                                                                />
                                                            </div>
                                                            <div style={{width: 120, height: 50}}>
                                                                <Select
                                                                    isDisabled={blockData}
                                                                    options={pointOptions}
                                                                    placeholder="Филиал"
                                                                    isClearable={true}
                                                                    value={data.point ? pointOptions.find((item) => item.value === data.point.id) : null}
                                                                    onChange={setPoint}
                                                                    isLoading={pointsLoading}
                                                                />
                                                            </div>

                                                            <div className="kt-subheader__mobile-actions">
                                                                <div style={{width: 175, height: 50}}>
                                                                <textarea
                                                                    className="custom-textarea"
                                                                    value={data.note}
                                                                    onChange={(e) => setInvoice('note')(e.target.value)}
                                                                    minLength={3}
                                                                    maxLength={500}
                                                                    placeholder="Примечание"
                                                                />
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <table className="kt-datatable__table" style={{marginTop: '160px', width: '100%' }}>
                                                <ErrorContainer field='invoices' hasCloseButton={true} style={{ margin: 25 }} />
                                                <tbody className="invoice-tbody">

                                                {data.raws.map((raw, index) => (
                                                    <tr key={raw.id} className="kt-datatable__row">
                                                        <td colSpan="100%" className="kt-datatable__cell">
                                                            <div className="invoice-item-container">
                                                                <div className="invoice-container-header">
                                                                    <div style={{ flex: 1 }}>
                                                                        <Select
                                                                            isDisabled={blockData}
                                                                            options={availableRawMaterialOptions(raw.id)}
                                                                            placeholder="Введите сырье"
                                                                            isClearable
                                                                            isLoading={rawMaterialsLoading}
                                                                            value={raw ? getRawValue(raw.id, raw.name) : null}
                                                                            onChange={option => handleMaterialChange(index, option)}
                                                                        />
                                                                    </div>
                                                                    <span style={{ width: '20px', display: 'inline-block' }}>
                                                                        {MEASURES_RAW[getRawValue(raw.id, raw.name).measure] || ''}
                                                                    </span>
                                                                    <button
                                                                        disabled={blockData}
                                                                        className="btn btn-sm btn-clean btn-icon btn-icon-md invoice-delete-btn"
                                                                        onClick={() => deleteRow(index)}>
                                                                        <i className="la la-trash"></i>
                                                                    </button>
                                                                </div>

                                                                <div className="invoice-field-row">
                                                                    <span className="invoice-field-label">Количество:</span>
                                                                    <input
                                                                        disabled={blockData}
                                                                        type="number"
                                                                        onFocus={(e) => e.target.select()}
                                                                        step="0.001"
                                                                        className="form-control invoice-input"
                                                                        value={parseNumToFixed(raw.quantity, 3) || 0}
                                                                        onChange={(e) => handleChange(index, 'quantity', parseNumToFixed(parseFloat(e.target.value), 3))}
                                                                    />
                                                                </div>

                                                                <div className="invoice-field-row">
                                                                    <span className="invoice-field-label">Цена:</span>
                                                                    <input
                                                                        disabled={blockData}
                                                                        type="number"
                                                                        onFocus={(e) => e.target.select()}
                                                                        step="0.001"
                                                                        className="form-control invoice-input"
                                                                        value={parseNumToFixed(raw.price) || 0}
                                                                        onChange={(e) => handleChange(index, 'price', parseNumToFixed(parseFloat(e.target.value)))}
                                                                    />
                                                                </div>

                                                                <div className="invoice-field-row">
                                                                    <span className="invoice-field-label">Сумма:</span>
                                                                    <input
                                                                        disabled={blockData}
                                                                        type="number"
                                                                        step="0.01"
                                                                        className="form-control invoice-input"
                                                                        value={parseNumToFixed(raw.totalPrice) || 0}
                                                                        onChange={(e) => handleChange(index, 'totalPrice', parseNumToFixed(parseFloat(e.target.value)))}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}

                                                {!blockData && <tr>
                                                    <td colSpan={5}>
                                                        <div style={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            padding: '10px 20px',
                                                            borderTop: '1px solid #e0e0e0',
                                                            alignItems: 'center'
                                                        }}>
                                                            <button
                                                                className="btn btn-primary"
                                                                onClick={addRow}
                                                                style={{ marginRight: 'auto' }}>
                                                                Добавить строку
                                                            </button>
                                                            <div style={{ fontWeight: 'bold', marginLeft: '10px' }}>
                                                                Общая сумма: {data.totalSum ? parseNumToFixed(data.totalSum) : parseNumToFixed(totalSum)}
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <ReactTooltip
                                effect="solid"
                                type="dark"
                                place="top"
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid" style={{marginTop: 25}}>
            <div className="kt-grid kt-grid--desktop kt-grid--ver-desktop kt-todo">
                <div className="kt-grid__item kt-grid__item--fluid kt-todo__content">
                    <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid"
                         style={{padding: 0}}>
                        <div className="kt-portlet kt-portlet--mobile">
                            <div className="kt-portlet__body kt-portlet__body--fit">
                                <div
                                    style={{position: 'relative', marginBottom: 0}}
                                    className={cn('kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded')}
                                >
                                    <div className="kt-subheader not-mt kt-grid__item">
                                        <div className="kt-container  kt-container--fluid">
                                            <div className="kt-subheader__main">
                                                <h3 className="kt-subheader__title">Накладная</h3>
                                                <span
                                                    className="kt-subheader__separator kt-subheader__separator--v"></span>
                                                <div className="kt-subheader__group" id="kt_subheader_search">
                                                    <BackButton/>
                                                    <button
                                                    onClick={handleSubmit}
                                                    className={cn({ 'btn btn-success  kt-spinner--right kt-spinner--sm kt-spinner--light': true, 'kt-spinner': loading })}
                                                    disabled={!isValid() || loading}>
                                                        Сохранить
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="kt-subheader not-mt kt-grid__item">
                                        <div className="kt-container kt-container--fluid">
                                            <div className="kt-subheader__main">
                                                <label className="kt-todo__text">
                                                    Номер:
                                                </label>
                                                <div style={{width: 200, height: 50, marginLeft: 10}}>
                                                    <Input
                                                        disabled={blockData}
                                                        placeholder="Номер"
                                                        value={data.number}
                                                        onChange={(e) => setInvoice('number')(e.target.value)}
                                                        isClearable={true}
                                                    />
                                                </div>
                                            </div>
                                            <div className="kt-subheader__main">
                                                <label className="kt-todo__text">
                                                    От:
                                                </label>
                                                <div style={{width: 200, height: 50, marginLeft: 10}}>
                                                    <DateInput
                                                        disabled={blockData}
                                                        showPopperArrow={false}
                                                        placeholderText="Дата"
                                                        selected={new Date(data.date)}
                                                        onChange={setInvoice('date')}
                                                        showTimeSelect
                                                        timeFormat="HH:mm:ss"
                                                        timeIntervals={1}
                                                        dateFormat="dd.MM.yyyy HH:mm:ss"
                                                    />
                                                </div>
                                            </div>
                                            <div className="kt-subheader__main">
                                                <label className="kt-todo__text">
                                                    Поставщик:
                                                </label>
                                                <div style={{width: 200, height: 50, marginLeft: 10}}>
                                                    <Select
                                                        isDisabled={blockData}
                                                        options={supplierOptions}
                                                        placeholder="Поставщик"
                                                        value={data.supplier
                                                            ? data.supplier.id 
                                                            ? { label: data.supplier.name, value: data.supplier.id } 
                                                            : supplierOptions.find((reason) => reason.id === data.supplier) 
                                                        : null}
                                                        isClearable={true}
                                                        onChange={setInvoice('supplier')}
                                                        isLoading={suppliersLoading}
                                                    />
                                                </div>
                                            </div>
                                            <div className="kt-subheader__main">
                                                <label className="kt-todo__text">
                                                    Филиал:
                                                </label>
                                                <div style={{width: 200, height: 50, marginLeft: 10}}>
                                                    <Select
                                                        isDisabled={blockData}
                                                        options={pointOptions}
                                                        placeholder="Филиал"
                                                        isClearable={true}
                                                        onChange={setPoint}
                                                        value={data.point ? pointOptions.find((item) => item.value === data.point.id) : null}
                                                        isLoading={pointsLoading}
                                                    />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="kt-subheader not-mt kt-grid__item">
                                        <div className="kt-container kt-container--fluid">
                                            <div className="kt-subheader__main">
                                                <div className="kt-subheader__main">
                                                    <label className="kt-todo__text">
                                                        Примечание:
                                                    </label>
                                                    <div style={{width: 400, height: 50, marginLeft: 10}}>
                                                        <textarea
                                                            style={textareaStyles}
                                                            value={data.note}
                                                            onChange={(e) => setInvoice('note')(e.target.value)}
                                                            minLength={3}
                                                            maxLength={500}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <table className="kt-datatable__table" style={{minHeight: '700px'}}>
                                        <ErrorContainer field='invoices' hasCloseButton={true} style={{ margin: 25 }} />
                                        <TableHeader UImobile={UImobile}/>
                                        <tbody className="kt-datatable__body">
                                        <>
                                            {data.rawMaterials.map((raw, index) => (
                                                <tr key={index} className="kt-datatable__row">
                                                    <td width="180px" className="kt-datatable__cell">
                                                        <Select
                                                            isDisabled={blockData}
                                                            options={availableRawMaterialOptions(raw.id)}
                                                            placeholder="Введите сырье"
                                                            isClearable
                                                            value={raw ? getRawValue(raw.id, raw.name) : null}
                                                            isLoading={rawMaterialsLoading}
                                                            onChange={option => handleMaterialChange(index, option)}
                                                        />
                                                    </td>
                                                    <td width="40px" className="kt-datatable__cell">
                                                        <span>{raw.id ? MEASURES_RAW[getRawValue(raw.id, raw.name).measure] || '' : ''}</span>
                                                    </td>
                                                    <td width="120px" className="kt-datatable__cell">
                                                        <input
                                                        disabled={blockData}
                                                        onFocus={(e) => e.target.select()}
                                                        type="number"
                                                        step="0.001"
                                                        className="form-control"
                                                        value={parseNumToFixed(raw.quantity, 3) || 0}
                                                        onChange={(e) => handleChange(index, 'quantity', parseNumToFixed(parseFloat(e.target.value), 3))}
                                                        />
                                                    </td>
                                                    <td width="120px" className="kt-datatable__cell">
                                                        <input
                                                        disabled={blockData}
                                                        onFocus={(e) => e.target.select()}
                                                        type="number"
                                                        step="0.01"
                                                        className="form-control"
                                                        value={parseNumToFixed(raw.price) || 0}
                                                        onChange={(e) => handleChange(index, 'price', parseNumToFixed(parseFloat(e.target.value)))}
                                                        />
                                                    </td>
                                                    <td width="310px" className="kt-datatable__cell">
                                                        <input
                                                        disabled={blockData}
                                                        onFocus={(e) => e.target.select()}
                                                        type="number"
                                                        step="0.01"
                                                        className="form-control"
                                                        value={parseNumToFixed(raw.totalPrice) || 0}
                                                        onChange={(e) => handleChange(index, 'totalPrice', parseNumToFixed(parseFloat(e.target.value)))}
                                                        style={{width: "195px"}}
                                                        />
                                                    </td>
                                                    <td align="right" width="180px" className="kt-datatable__cell">
                                                        <button
                                                            disabled={blockData}
                                                            className="btn btn-sm btn-clean btn-icon btn-icon-md"
                                                            onClick={() => deleteRow(index)}>
                                                            <i className="la la-trash"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                            {!blockData && <tr>
                                                <td colSpan={5}>
                                                    <div style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        padding: '10px 20px',
                                                        borderTop: '1px solid #e0e0e0',
                                                        alignItems: 'center'
                                                    }}>
                                                        <button className="btn btn-primary" onClick={addRow} style={{marginRight: 'auto'}}>
                                                            Добавить строку
                                                        </button>
                                                        <div style={{fontWeight: 'bold', marginLeft: '10px'}}>
                                                            Общая сумма: {data.totalSum ? parseNumToFixed(data.totalSum) : parseNumToFixed(totalSum)}
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>}
                                        </>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ReactTooltip
                        effect="solid"
                        type="dark"
                        place="top"
                    />
                </div>
            </div>
        </div>
    )
};

export default InvoiceForm;
